import React, {Component} from 'react';
import JobListDivRow from "./JobListDivRow";

class JobsListDivs extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {jobs} = this.props;
        return (
            <div>
            {
                jobs.map(job =>
                    <JobListDivRow
                        key={job.id}
                        job={job}
                        cloneJob={this.props.cloneJob}
                        showJobDeleteModal={this.props.showJobDeleteModal}
                    />
                )
            }
            </div>
        )
    }
}

export default JobsListDivs;




// WEBPACK FOOTER //
// ./web/src/components/jobs/JobsListDivs.jsx